import React from "react";
import { Card, Col, Row } from "antd";

import people from "../../../assets/icons/people.no-white.png";
import chart from "../../../assets/icons/presention-chart.svg";
import user from "../../../assets/icons/user-tag.svg";

import "../style.css"

const cardsConfig = [
  {
    id: 1,
    title: "Total Users",
    valueKey: "totalUsers",
    icon: people,
  },
  {
    id: 2,
    title: "Growth Rate",
    valueKey: "growthRate",
    icon: chart,
  },
  {
    id: 3,
    title: "Active Users",
    valueKey: "ActiveUsers", 
    icon: user,
  },
];

export default function SummaryCards({ data, period }) {
  return (
    <Card>
      <Row gutter={[16, 16]} justify="center">
        {cardsConfig.map((card) => (
          <Col key={card.id} xs={24} sm={24} md={12} lg={8}>
            <div
              style={{
                height: 108,
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                background: "rgba(223, 218, 255, 0.7)",
                borderRadius: "8px",
              }}
            >
              <div className="circle" style={{ marginLeft: 15 }}>
                <img className="icon-center" src={card.icon} alt="" />
              </div>
              <div style={{ marginLeft: 20 }}>
                <div style={{ fontSize: 20, fontWeight: 400, color: "#4D3280", marginBottom: 5 }}>{card.id === 3 && period.charAt(0).toUpperCase() + period.slice(1)} {card.title}</div>
                <div style={{ fontSize: 24, color: "#5D3B9C", fontWeight: 700 }}>{data ? data.summary_data[card.valueKey].toFixed(2) : '-'}</div>
              </div>
            </div>
          </Col>
        ))}
      </Row>  
    </Card>
  );
}
